import { HttpInterceptorFn } from "@angular/common/http";
import { authInterceptor } from "./auth.interceptor";
import { baseUrlInterceptor } from "./base-url.interceptor";
import { forbiddenErrorInterceptor } from "./error/forbidden-error.interceptor";
import { globalErrorInterceptor } from "./error/global-error.interceptor";
import { unauthorizedErrorInterceptor } from "./error/unauthorized-error.interceptor";
import { validationErrorInterceptor } from "./error/validation-error.interceptor";
import { enterpriseInterceptor } from "./enterprise.interceptor";
import { loaderInterceptor } from "./loader.interceptor";
import { networkInterceptor } from "./network.interceptor";

export const interceptors: HttpInterceptorFn[] = [
  networkInterceptor,
  baseUrlInterceptor,
  enterpriseInterceptor,
  authInterceptor,
  loaderInterceptor,
  globalErrorInterceptor,
  validationErrorInterceptor,
  unauthorizedErrorInterceptor,
  forbiddenErrorInterceptor,
];
